import { useCallback, useEffect, useState } from 'react';
import { X, CalendarClock, CheckCircle2 } from 'lucide-react';
import CalendlyInline from './CalendlyInline';

const CLOSE_DELAY = 4000;

export const ScheduleMeetingPanel = ({ onClose }) => {
  const [booked, setBooked] = useState(false);
  const handleScheduled = useCallback(() => setBooked(true), []);

  useEffect(() => {
    if (!booked) return undefined;
    const t = setTimeout(onClose, CLOSE_DELAY);
    return () => clearTimeout(t);
  }, [booked, onClose]);

  return (
    <section
      id="schedule-a-meeting"
      data-testid="schedule-meeting-panel"
      className="bg-[var(--mm-purple-dark)] border-t border-[var(--mm-purple-mid)]"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-10 md:py-14">
        <div className="flex items-start justify-between gap-6 mb-7">
          <div>
            <p className="inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.18em] uppercase text-[var(--mm-cream)]/55">
              <CalendarClock className="w-3.5 h-3.5" /> 30-minute conversation
            </p>
            <h2 className="mt-3 text-base md:text-lg font-semibold text-white max-w-2xl leading-snug">
              Pick a slot that works for you. We will walk you through classroom execution,
              deployment timelines and what it takes to run this at scale.
            </h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close scheduler"
            data-testid="schedule-meeting-close"
            className="shrink-0 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {booked ? (
          <div
            data-testid="schedule-meeting-confirmation"
            role="status"
            className="rounded-2xl bg-white/[0.06] border border-[#00E599]/30 px-6 py-14 md:py-20 text-center"
          >
            <CheckCircle2 className="w-12 h-12 text-[#00E599] mx-auto" />
            <h3 className="mt-5 text-base md:text-lg font-semibold text-white">
              You are booked. A calendar invite is on its way to your inbox.
            </h3>
            <p className="mt-2 text-sm text-white/60">Closing this in a moment…</p>
          </div>
        ) : (
          <div className="rounded-2xl overflow-hidden bg-white">
            <CalendlyInline onEventScheduled={handleScheduled} />
          </div>
        )}
      </div>
    </section>
  );
};

export default ScheduleMeetingPanel;
